import { useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { MineralDto } from '../application/dto/MineralDto';
import { MineralCard } from './MineralCard';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import './MineralsPage.css';

export function MineralsPage() {
  const minerals = useLoaderData() as MineralDto[];
  useDocumentHead(staticSeo.mineralsList);

  return (
    <Container>
      <section className="dma-minerals-page">
        <h1>محصولات و مواد معدنی</h1>
        <div className="dma-minerals-page__grid">
          {minerals.map((mineral) => (
            <MineralCard key={mineral.id} mineral={mineral} />
          ))}
        </div>
      </section>
    </Container>
  );
}
